import CustomButton from "./CustomButton";
import { Box, Button, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { deleteDiaryEntry } from "../features/Diary/DiarySlice";
// import "../styles/components/delete-habit.scss";
import "../styles/components/delete-diary-entry.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface DeleteProps {
  entry_id: number;
}

const DeleteDiaryEntry: React.FC<DeleteProps> = ({ entry_id }: DeleteProps) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const deleteDispatcher = async () => {
    const output = (await dispatch(deleteDiaryEntry({ entry_id }))) as any;
    if (output?.type === "habit/deleteDiaryEntry/fulfilled") {
      handleClose();
      history.push("/diary");
    }
  };
  return (
    <>
      <CustomButton
        className="delete-button"
        onClick={handleOpen}
        style={{
          backgroundColor: "white",
          border: "2px solid black",
          color: "black",
          width: "100%",
        }}
        displayText="Delete Entry"
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="delete-diary-entry-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
          className="box"
        >
          <h2>Are you sure you want to delete this entry?</h2>
          <CustomButton
            onClick={deleteDispatcher}
            className="warning-button"
            style={{
              color: "black",
              background: "rgba(255, 119, 119)",
              border: "2px solid black",
              width: "12.5rem",
            }}
            displayText="Delete Entry"
          />
        </Box>
      </Modal>
    </>
  );
};

export default DeleteDiaryEntry;
